import { Injectable } from '@angular/core';
import { RestApiService } from '../shared/rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class CourseService {

  constructor(private api: RestApiService) { }

  getCourseUnit(unitId: string): any {
    return this.api.getOne('course', unitId);
  }

  getCourseUnitRealization(unitId: string): any {
    // return this.api.getSubList('course/realization', unitId);
    return this.api.getSubList('realizations/course', unitId);
  }

  getPastCourseUnitRealization(unitId: string): any {
    return this.api.getSubList('realizations/past/course', unitId);
  }

  getText(key: string): any{
    return this.api.getOne('course/text', key);
 }

}
